import { action, makeObservable, observable } from 'mobx';
import { gameModuleService } from '../services/gameModuleService';
import { GAME_SPEED_TYPES } from '../../constants/gameConstants';
import { specialIconKeys } from '../../constants/symbolsNames';
import { gameGlobalStates } from '../../constants/reelConstants';


class GameModuleStore {
  initialMatrix = [];
  resultMatrix = [];
  doSpin = null;
  soundService = null;
  animationEnd = null;
  gameGlobalState = gameGlobalStates.none;
  spinSpeedType = 'standard';
  spinDirection = 1;
  additional = null;
  wins = [];
  isForceStop = false;
  awaitForceStop = false;
  canTouchControl = true;
  winAnimations = [];
  responseReady = false;
  hasJackpot = 0;
  scatter1Count = 0;
  scatter2Count = 0;


  constructor() {
    makeObservable(this, {
      initialMatrix: observable,
      resultMatrix: observable,
      additional: observable,
      doSpin: observable,
      soundService: observable,
      animationEnd: observable,
      gameGlobalState: observable,
      spinSpeedType: observable,
      spinDirection: observable,
      isForceStop: observable,
      awaitForceStop: observable,
      canTouchControl: observable,
      winAnimations: observable,
      responseReady: observable,
      scatter1Count: observable,
      scatter2Count: observable,
      getPropsFromFrame: action.bound,
      setResultMatrix: action.bound,
      setSpinSpeedType: action.bound,
      setSpinDirection: action.bound,
      handleReelAnimationEnd: action.bound,
      setResponseReady: action.bound,
      setAdditional: action.bound,
      setIsForceStop: action.bound,
      setGameGlobalState: action.bound,
      setCanTouchControl: action.bound,
      setWinAnimations: action.bound,
      setAwaitForceStop: action.bound,
      setScatterCount: action.bound,
    });
  }

  getPropsFromFrame = ({ initialMatrix, doSpin, soundService, animationEnd, result }) => {
    this.initialMatrix = initialMatrix;
    this.doSpin = doSpin;
    this.soundService = soundService;
    this.animationEnd = animationEnd;
  };

  setSpinSpeedType = (type) => {
    this.spinSpeedType = type;
  };
  setGameGlobalState = (state) => {
    this.gameGlobalState = state;
  };

  setSpinDirection = (direction) => {
    this.spinDirection = direction;
  };

  handleReelAnimationEnd = () => {
    const { wins, expandingWild } = this?.additional || {};
    if (this.hasJackpot) {
      gameModuleService.startJackpotSymblsAnimation();
    }
    if (expandingWild && expandingWild.includes(specialIconKeys.wild)) {
      gameModuleService.startWildAnimation(expandingWild, wins);
    } else if (wins?.length) {
      this.wins = wins;
      gameModuleService.startWinAnimation(wins);
    } else {
      this.animationEnd('noWin');
      this.setCanTouchControl(true);
      gameModuleStore.setGameGlobalState(gameGlobalStates.none);
    }
    this.awaitForceStop = false;
    this.isForceStop = false;
    this.setResponseReady(false);

  };

  setResponseReady = (status) => {
    this.responseReady = status;
  };

  setAdditional = (additional) => {
    this.additional = additional;
  };

  setIsForceStop = (status) => {
    if (this.spinSpeedType === GAME_SPEED_TYPES.turbo || this.isForceStop) return;
    this.isForceStop = status;
  };

  setAwaitForceStop = (status) => {
    this.awaitForceStop = status;
  };

  setCanTouchControl = (status) => {
    this.canTouchControl = status;
  };

  setWinAnimations = (animation) => {
    animation ? this.winAnimations.push(animation) : this.winAnimations = [];
  };

  setHasJackpot = (jackpotSymbolsCount) => {
    this.hasJackpot = jackpotSymbolsCount === 3;
  };
  setResultMatrix = (matrix) => {
    this.resultMatrix = matrix;
  };

  setScatterCount = (type) => {
    switch (type) {
      case 'scatter1':
        this.scatter1Count += 1;
        break;
      case 'scatter2':
        this.scatter2Count += 1;
        break;
      case 'reset':
        this.scatter1Count = 0;
        this.scatter2Count = 0;
        break;
    }
  };

}

export const gameModuleStore = new GameModuleStore();